// import {HttpService} from '../../../../core/services/http.service';
import {
  Component,
  EventEmitter,
  forwardRef,
  Input,
  NgZone,
  OnChanges,
  OnInit,
  Output,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { NgbTooltipConfig } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { Subscription } from 'rxjs';
import { UtilityCommon } from '../../../../common/utils/utility-common';

declare var $: any;

export const COMBO_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => NgSelectComboComponent),
  multi: true
};

@Component({
  selector: '[ng-select-combo]',
  templateUrl: 'ng-select-combo.component.html',
  providers: [COMBO_VALUE_ACCESSOR, NgbTooltipConfig, UtilityCommon]
})
export class NgSelectComboComponent implements  OnInit, OnChanges, ControlValueAccessor {

    @Input()
    label: string;

    @Input()
    required: boolean = false;

    @Input()
    options: any;

    @Input()
    allowClear: boolean = true;

    @Input()
    optionSel: any = null;

    @Input()
    disabled: boolean;

    @Output()
    onChangeSel = new EventEmitter();

    @Input()
    optionLabel: string = 'descrizione';

    @Input()
    tooltip: boolean;

    optionsIO: Array<any>;
    valueSel: string ;
    noFilter: number = 0;
    submitPending: boolean;
    randomId: string = this.getRandomId();
    subscription: Subscription = null;
    _value: string;
    private onTouchedCallback: () => void = () => { };
    private onChangeCallback: (_: any) => void = () => { };

    @ViewChild('ngSelectCombo') public ngSelect: NgSelectComponent;


    constructor(
        // private httpService: HttpService,
        private zone:NgZone,
        public utilityCommon: UtilityCommon,
    ){
    }



    ngAfterViewInit() {
        const id = 'ngSelect_' + this.randomId;
        const inputEl = this.ngSelect.element.querySelector('input');
        if (inputEl) inputEl.id = id;
    }


    ngOnChanges(): void {

        /*//Converte la lista di options passata in un array di optionsIO
        this.optionsIO = this.options.map(option => ({value: option.id, label: option.label}));

        //Solo se la tendina ha almeno 1 valore...
        if(this.optionsIO.length > 0) {

            //Se la lista di options è più lunga del valore max, allora fa apparire la casella di ricerca...
            if (this.optionsIO.length > 4) {
                this.noFilter = this.optionsIO.length - 1;
            } else {
                //...altrimenti la disabilita
                this.noFilter = parseInt('Infinity');
            }

            //Se è presente un oggetto option selezionato...
            if (this.optionSel) {
                //Solo se l'oggetto option selezionato è diverso da quello attualmente già selezionato, lo seleziona
                if (this.valueSel !== this.optionSel.id.toString()) {
                    //Si usa il timeout asincrono in quanto è presente un bug nella libreria (fixato in una versione non compatibile con il nostro angular2
                    setTimeout(()=>{ this.valueSel = this.optionSel.id.toString() });
                }
            } else {
                //...altrimenti se non è presente l'oggetto option selezionato, esegue il clear solo se c'era precedentemente un oggetto selezionato
                if (this.valueSel) {
                    this.ngSelect.handleClearClick(); // todo: testing
                }
            }
        }*/
    }


    ngOnInit(): void {

        //Avvia sistema di disabilitazione automatica della tendina quando una chiamata http è in corso
        /*if (!this.submitPending) {
            this.createServiceSubscription();
        }*/
    }


    onSelected(optionIO) {
        // this.onChangeSel.emit(this.options.find(option => option.id == optionIO.value));
        this.onChangeSel.emit(optionIO);
    }


    onDeselected(optionIO) {
        this.onChangeSel.emit(null);
    }


    private createServiceSubscription() {
        /*this.subscription = this.httpService.enableObservable.subscribe(show => {
            if (show) {
                this.submitPending = true;
            } else {
                this.submitPending = false;
            }
        });*/
    }


    writeValue(value: any): void {
        this._value = value;
    }

    registerOnChange(fn: any): void {
        this.onChangeCallback = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    getRandomId(length: number = 10): string {
        return crypto.randomUUID();
    }

    compareFn(a, b) {
        return a == b;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

}
